import React from 'react'
import PropTypes from 'prop-types'

const LoadingSpinner = ({ text, outerClass = '', innerClass = '', style = {} }) => {
  const classes = `icon icon_spinner10 icon_spin2 spinner LoadingSpinner mb-2 ${innerClass}`

  return (
    <div className={outerClass} data-testid="loading-spinner">
      <div style={style} className={classes} />
      {text && <p>{text}</p>}
    </div>
  )
}

LoadingSpinner.propTypes = {
  style: PropTypes.object,
  text: PropTypes.string,
  outerClass: PropTypes.string,
  innerClass: PropTypes.string,
}

export default LoadingSpinner
